var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","text-align":"center","font-size":"30px"}},[_vm._v("欢迎登录后台管理系统\n\n  "),_c('div',{staticStyle:{"width":"100%","text-align":"center","font-size":"30px"}},[_vm._v("当前用户:"+_vm._s(_vm.username))])])
}
var staticRenderFns = []

export { render, staticRenderFns }